var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notLoginPage && _vm.catalog)?_c('div',{class:['cart-wrapper', {'cart-open': _vm.isCartOpen, 'cart-closed': !_vm.isCartOpen}]},[_c('cart')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }